import { Col, Form, Input, Row } from "@ir/ui";

const ContactInfo = ({ nameLabel, emailLabel }: { nameLabel: string, emailLabel: string }) => {
  return (
    <Row>
      <Col span={6}>
        <Form.Item
          name="contactName"
          rules={[
            { required: true, message: "Contact Name is required." },
            { max: 50, message: "Contact Name must be less than 50 characters." },
          ]}
          label={nameLabel}
        >
          <Input type="text" />
        </Form.Item>
      </Col>
      <Col span={6}>
        <Form.Item
          name="contactEmail"
          rules={[
            { required: true, message: "Contact Email is required." },
            { type: "email", message: "Please enter a valid email address." },
          ]}
          label={emailLabel}
        >
          <Input type="email" />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default ContactInfo;
